import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"
import { unless, eq, when, maxWidth } from "utils"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};

  ${unless("fullWidth")`
    ${eq("size", "Small")`
      padding: 0 37.5%;
    `}

    ${eq("size", "Medium")`
      padding: 0 25%;
    `}

    ${eq("size", "Large")`
      padding: 0 12.5%;
    `}
  `}

  ${(props) =>
    props.theme.component.isNested &&
    `
    padding: 0;
  `}

  ${maxWidth.mobile`
    padding: 0;

    ${when("hideOnMobile")`
      display: none;
    `}
  `}

  background-color: ${(props) => props.theme.component.background};
`

export const ImageComponent = styled(CloudinaryImage)`
  ${when("height")`
    height: ${(props) => props.height / 10}rem;
  `}

  ${unless("height")`
    padding-top: ${(props) => props.aspectRatios.desktop * 100}%;
  `}

  ${maxWidth.tablet`
    ${unless("height")`
      padding-top: ${(props) => props.aspectRatios.tablet * 100}%;
    `}
  `}

  ${maxWidth.mobile`
    height: 0;
    padding-top: ${(props) => props.aspectRatios.mobile * 100}%;
  `}
`
